/** WonderCoin — the gold "W" medallion shown next to every Wonders amount. */
import React from 'react';

export const WonderCoin = ({ size = 16, className = '' }) => (
  <img
    src="/wonders/coin.png"
    alt=""
    aria-hidden
    width={size}
    height={size}
    className={`inline-block align-[-2px] ${className}`}
    style={{ width: size, height: size }}
    data-testid="wonder-coin"
  />
);
